<template>
  <div
    id="content"
    class="flex-column"
  >
    <p class="title">
      Em análise
    </p>
    <p class="text">
      Estamos processando os dados enviados, isso pode levar algum tempo.
    </p>
    <img src="@/assets/tudo-pronto.svg">
    <div class="summary">
      <h4>Progresso</h4>
      <RBSummary :steps="steps" />
    </div>
    <RbButton
      text="Acessar portal"
      class="portal-button flex-column"
      :href="href"
      target="_blank"
      rounded
      primary
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { proposalStore } from '@/store/app';
import RBSummary from '../standards/RBSummary.vue';
import RbButton from '../standards/RbButton.vue';

const steps = [
  {
    title: 'Cadastro de proposta',
    content: 'Envio de dados para a plataforma. O aluno só pode realizar uma proposta por vez, caso faça uma nova, esta não será considerada.',
    open: true,
    active: true
  },
  {
    title: 'Análise Pravaler',
    content: 'Nossa equipe fará uma análise de crédito sobre as suas informações.',
    open: true,
    active: true
  },
  {
    title: 'Análise da Instituição de Ensino',
    content: 'A instituição vai confirmar o valor do seu curso e o período financiado. Você precisa estar matriculado para passar dessa etapa. Se você já se matriculou, acompanhe a análise no Portal.',
    open: false
  },
  {
    title: 'Dados complementares',
    content: 'Preencha os dados obrigatórios no Portal para finalizarmos o seu contrato.',
    open: false
  },
  {
    title: 'Envio de documentos',
    content: 'Separe os comprovantes de Identidade e de Renda. Você precisará enviar fotos deles nessa etapa.',
    open: false
  },
  {
    title: 'Assine o contrato online e pronto!',
    content: 'Comece a estudar pagando menos na sua mensalidade!',
    open: false
  }
];

const href = computed(() => 'https://cadastro.pravaler.com.br/?proposalToken=' + proposalStore().getProposal().token);
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}

#content {
  margin: 1.3rem 1.15rem;
  gap: 16px;

  .title {
    font-family: Poppins;
    font-size: 1rem;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
  }

  .text {
    font-size: 0.90rem;
    font-weight: 400;
    line-height: 1.45rem;
    letter-spacing: 0.025em;
    text-align: left;
    color: rgba(77, 77, 77, 1);
  }

  &>img {
    width: 193px;
    margin: 0 auto;
  }

  &>div.summary {
    h4 {
      color: var(--secondary);
      margin: 16px 0;
    }
  }

  &>.portal-button {
    margin: 32px 16px 0;
  }
}
</style>
